import {
  EMPTY_CURRENT_PERMISSIONS,
  FULL_CURRENT_PERMISSIONS,
} from 'interfaces/currentPermissions'
import {
  createLmsAccessFromPayload,
  LmsAccess,
  readSessionAccess,
} from './lmsAccess'

/**
 * Snapshot del evaluador actual (misma instancia conceptual que useAccess).
 * AccessProvider lo actualiza al cargar JWT / roles/current.
 * Sagas y código no-React usan getAccess() con la misma API: isAdmin(), can(), …
 */
let snapshot: LmsAccess | null = null

export const setAccessSnapshot = (access: LmsAccess) => {
  snapshot = access
}

/** Fallback si aún no hidrató el provider (p. ej. saga muy temprana). */
const bootstrapAccess = (): LmsAccess => {
  const { hasFullAccess, isSuperadmin } = readSessionAccess()
  return createLmsAccessFromPayload(
    hasFullAccess,
    hasFullAccess ? FULL_CURRENT_PERMISSIONS : EMPTY_CURRENT_PERMISSIONS,
    isSuperadmin
  )
}

/**
 * Misma forma que los métodos de useAccess(), usable fuera de React (sagas).
 *
 * @example
 * getAccess().isAdmin()
 * getAccess().can('manageCourseRequests')
 */
export const getAccess = (): LmsAccess => snapshot ?? bootstrapAccess()
